export const iconColorBgColor = {
    "address": { color: "#141BCB", bgColor: "#E8E8FA" },
    "attachment": { color: "#0A99FE", bgColor: "#E7F5FF" },
    "checkbox": { color: "#EB2F96", bgColor: "#FFF0F6" },
    "contact": { color: "#FAAD14", bgColor: "#FFFBE6" },
    "date": { color: "#50A248", bgColor: "#EEF6ED" },
    "dropdown": { color: "#722ED1", bgColor: "#F9F0FF" },
    "image": { color: "#EB2F96", bgColor: "#FFF0F6" },
    "info": { color: "#FA8C16", bgColor: "#FFF7E6" },
    "link": { color: "#722ED1", bgColor: "#F9F0FF" },
    "multipleChoice": { color: "#F5222D", bgColor: "#FFF1F0" },
    "number": { color: "#FA541C", bgColor: "#FFF2E8" },
    "radio": { color: "#50A248", bgColor: "#EEF6ED" },
    "switch": { color: "#141BCB", bgColor: "#E8E8FA" },
    "table": { color: "#0A99FE", bgColor: "#E7F5FF" },
    "input": { color: "#F5222D", bgColor: "#FFF1F0" },
    "textArea": { color: "#FA8C16", bgColor: "#FFFBE6" },
    "time": { color: "#50A248", bgColor: "#EEF6ED" },
    "rating": { color: "#FAAD14", bgColor: "#FFFBE6" },

}

export const spaceColorBgMapping = {
    "#F5222D": "#FFF1F0",
    "#FA8C16": "#FFF7E6",
    "#FAAD14": "#FFF7E6",
    "#84CC16": "#ECF8D9",
    "#50A248": "#EEF6ED",
    "#13C2C2": "#D9F5F5",
    "#0A99FE": "#E7F5FF",
    "#141BCB": "#e8e9fd",
    "#722ED1": "#F5EEFF",
    "#EB2F96": "#FFE9F5"
}

export const dbColorIconBgMapping = {
    "#F5222D": "#FFCCC7",
    "#FA8C16": "#FFE7BA",
    "#FAAD14": "#FFF1B8",
    "#84CC16": "#E1F3C7",
    "#50A248": "#D5E9D3",
    "#13C2C2": "#B5F5EC",
    "#0A99FE": "#C4E7FF",
    "#141BCB": "#C7C8F3",
    "#722ED1": "#EFDBFF",
    "#EB2F96": "#FFD6E7"
}

export const spaceIconsConfig = [
    "prism",
    "analysis",
    "attachment",
    "bulb",
    "business-analysis",
    "business-process",
    "business",
    "clock",
    "database",
    "date",
    "file",
    "folder",
    "goal",
    "handshake",
    "hierarchy",
    "legal",
    "location",
    "management",
    "network1",
    "network2",
    "payment",
    "procurement1",
    "procurement2",
    "rate",
    "sales1",
    "sales2",
    "security",
    "settings1",
    "settings2",
    "star",
    "tools",
    "travel",
    "user",
    "user-setting",
    "user-group"
]

export const workflowIconsConfig = [
    "scale",
    "fileOutlined",
    "fileEditOutlined",
    "fileEdit",
    "fileChecked",
    "fileCheckedOutlined",
    "checkOutlined",
    "editFilled",
    "editOutlined"
]

export const sprintColorBgMapping = {
    "#F5222D": "#fa7077",
    "#FA8C16": "#fcb870",
    "#FAAD14": "#FFD666",
    "#84CC16": "#c0f66f",
    "#50A248": "#82c97b",
    "#13C2C2": "#7debeb",
    "#0A99FE": "#65BFFE",
    "#141BCB": "#6e74fc",
    "#722ED1": "#a469f7",
    "#EB2F96": "#FF85C0",
}

export const colorTagMapping = {
    "#F5222D": "red",
    "#FA8C16": "orange",
    "#FAAD14": "gold",
    "#84CC16": "lime",
    "#50A248": "green",
    "#13C2C2": "cyan",
    "#0A99FE": "blue",
    "#141BCB": "geekblue",
    "#722ED1": "purple",
    "#EB2F96": "magenta"
}

export const statusColorMapping = {
    "refused": "#F5222D",
    "approved": "#50A248",
    "archived": "#84CC16",
    "draft": "#722ED1",
    "closed": "#f46e6e",
    "deleted": "#d4380d"
}